<template>
  <ss-modal
    v-show="show"
    title="Overpayment Settlement Form"
    intro="bounceIn"
    utro ="bounceOut">
    <!-- HEADER -->
    <div slot="modal-header">
      <template v-if="selectedSettlement">
        Edycja rozliczenia
      </template>
      <template v-else>
        Nowe rozliczenie
      </template>
      <i
        class="close"
        @click.prevent="$emit('update:show', false)">
      </i>
    </div>
    <!-- BODY -->
    <div slot="modal-body">
      <div class="form-group">
        <label>Kwota</label>
        <ss-price-input
          name="amount"
          v-model="amount"
          @input="lar_errors.clear('amount')"
          :class="{'is-invalid' : lar_errors.has('amount')}"
          placeholder=""/>
        <div class="invalid-feedback" v-text="lar_errors.get('amount')"></div>
      </div>

      <div class="form-group">
        <label>Data realizacji</label>
        <ss-date
          v-model="date"
          type="text"
          name="settlement_date"
          placeholder="Wybierz datę"/>
      </div>

      <div class="form-group">
        <ss-textarea
          v-model="description"
          name="description"
          label="Krótki opis"
          placeholder="Krótki opis"
          :class="{'is-invalid' : lar_errors.has('description')}">
        </ss-textarea>
      </div>
    </div>
    <!-- FOOTER -->
    <div slot="modal-footer">
      <d-button
        theme="danger"
        @click.prevent="$emit('update:show', false)" >
        Zamknij
      </d-button>
      <d-button
        theme="success"
        class="ml-3"
        @click.prevent="submitSettlement">
        <i class="material-icons">save</i> Zapisz
      </d-button>
    </div>
  </ss-modal>
</template>

<script>
import Vue from 'vue';
import SsModal from '@/components/common/SsModal';
import SsDate from '@/components/common/SsDate';
import SsPriceInput from '@/components/common/SsPriceInput';
import LarErrors from '@/helpers/Errors';
import FormUtils from '@/utils/FormUtils.js';

export default {
  name: 'OverpaymentSettlementModal',
  components: {
    SsModal,
    SsDate,
    SsPriceInput
  },
  props: {
    closeCallback: {
      type: Function,
      required: true
    },
    scheduleId: {
      type: Number,
      required: true
    },
    selectedSettlement: {
      type: Object,
      default: null
    },
    show: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    isEdit () {
      return !!this.selectedSettlement;
    }
  },
  watch: {
    show (newVal) {
      if (!newVal) {
        this.closePopup();
        return;
      }
      if (this.selectedSettlement) {
        Vue.set(this, 'id', this.selectedSettlement.id);
        Vue.set(this, 'amount', this.selectedSettlement.amount);
        Vue.set(this, 'date', this.selectedSettlement.date);
        Vue.set(this, 'description', this.selectedSettlement.description);
        Vue.set(this, 'schedule_id', this.selectedSettlement.schedule_id);
      } else {
        Vue.set(this, 'id', 0);
        Vue.set(this, 'amount', 0);
        Vue.set(this, 'date', null);
        Vue.set(this, 'description', '');
        Vue.set(this, 'schedule_id', this.scheduleId);
      }
    }
  },
  data () {
    return {
      id: 0,
      amount: 0,
      date: null,
      description: '',
      schedule_id: 0,
      actionInProgress: false,
      lar_errors: LarErrors,
    }
  },
  mounted () {

  },
  methods: {
    closePopup (shouldReload = false) {
      LarErrors.clear();
      this.closeCallback(shouldReload);
    },
    submitSettlement () {
      Vue.set(this, 'actionInProgress', true);
      let formDataToSend = this.prepareFormDataToSend()

      let endpointUrl = this.isEdit ? 'api/overpayment-settlement/update/' + this.id : 'api/overpayment-settlement/store';
      FormUtils.submit(this, {
        endpoint: endpointUrl,
        formData: formDataToSend,
        successTitle: 'Rozliczenie zostało zapisane.',
        successText: '',
        errorTitle: 'Wystąpił błąd',
        errorText: 'Zapisywanie rozliczenia nie powiodło się. Spróbuj ponownie.',
        successAction: () => {
          Vue.set(this, 'actionInProgress', false);
          this.closePopup(true);
        },
        failAction: (response) => {
          Vue.set(this, 'actionInProgress', false);
          LarErrors.record(response.data.errors);
        }
      });
    },
    prepareFormDataToSend () {
      let formDataToSend = {
        amount: this.amount,
        description: this.description,
        schedule_id: this.scheduleId,
      }

      if (this.isEdit || this.date) {
        formDataToSend.date = this.date;
      }

      return formDataToSend;
    }
  }
}
</script>